import axios from 'axios';
import Errors from './errorsHandler';
import generateUUIDs from './generateUUIDs';

window.cancelSource = axios.CancelToken.source();

const axiosRequest = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

axiosRequest.interceptors.request.use(
    async (axiosConfig) => {
        const [storageUUID, cookieUUID, browserUUID] = await generateUUIDs();

        axiosConfig.headers = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'Storage-UUID': storageUUID,
            'Cookie-UUID': cookieUUID,
            'Browser-UUID': browserUUID
        };

        return axiosConfig;
    },
    (err) => {
        Errors.errorSwitch(
            err.response?.status,
            'Request error',
            {
                status: err.response?.status,
                url: err.response?.config?.url,
                method: err.response?.config?.method
            },
            err.response?.data?.data
        );
        return Promise.reject(err);
    }
);

axiosRequest.interceptors.response.use(
    (response) => response,
    (error) => {
        Errors.errorSwitch(
            error?.response?.status,
            'Response error',
            {
                status: error?.response?.status,
                url: error?.response?.config?.url,
                method: error?.response?.config?.method
            },
            error?.response?.data?.data
        );
        return Promise.reject(error);
    }
);

export default axiosRequest;
